import { Capacitor } from "@capacitor/core";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { Share } from "@capacitor/share";
import axios from "axios";
import axiosInstance from "../../helpers/axios";
import {
  requestPayloadBodyFormate,
  responseDataFormate,
} from "../../helpers/bycrypt";
import {
  catchHandler,
  dispatchError,
  dispatchLoading,
  dispatchToast,
  elseHandler,
} from "../../helpers/dispatch";

let invoiceCancelTokenSource: any;

export const GetInvoicesListAPI =
  (
    {
      page,
      limit,
      search,
      status,
      customer_id,
      invoice_type,
      start_date,
      end_date,
      sortBy,
      sortOrder,
    }: any,
    setHasMore: any,
  ) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getInvoices", true);
    if (invoiceCancelTokenSource) {
      invoiceCancelTokenSource.cancel();
    }
    invoiceCancelTokenSource = axios.CancelToken.source();
    let params: any = {};
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;
    if (search) params["search"] = search;
    if (status) params["status"] = status;
    if (customer_id) params["customer_id"] = customer_id;
    if (invoice_type) params["invoice_type"] = invoice_type;
    if (start_date) params["start_date"] = start_date;
    if (end_date) params["end_date"] = end_date;
    if (sortBy) params["sortBy"] = sortBy;
    if (sortOrder) params["sortOrder"] = sortOrder;

    axiosInstance
      .get(`/invoices`, {
        params: { ...params },
        cancelToken: invoiceCancelTokenSource.token,
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "GET_INVOICE_LIST",
            payload: {
              page: page,
              data: result?.data?.data,
              count: result?.data?.total,
            },
          });
          if (setHasMore) {
            setHasMore(result?.data?.data?.length == limit);
          }
        } else {
          elseHandler(dispatch, "getInvoices", result);
        }
        dispatchLoading(dispatch, "getInvoices", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getInvoices")(err);
      });
  };

export const GetInvoiceDetailsAPI =
  (id: string, setState?: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getInvoiceDetails", true);

    axiosInstance
      .get(`/invoices/${id}`)
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "GET_INVOICE_DETAILS",
            payload: result?.data,
          });
          setState && setState(result?.data);
        } else {
          elseHandler(dispatch, "getInvoiceDetails", result);
        }
        dispatchLoading(dispatch, "getInvoiceDetails", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getInvoiceDetails")(err);
      });
  };

export const GetCheckInvoiceExistAPI =
  (id: string, onSuccess: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "checkInvoiceExist", true);

    axiosInstance
      .get(`/invoices/check-invoice-exists?order_id=${id}`)
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          if (onSuccess) onSuccess(result?.data);
        } else {
          elseHandler(dispatch, "checkInvoiceExist", result);
        }
        dispatchLoading(dispatch, "checkInvoiceExist", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "checkInvoiceExist")(err);
      });
  };

export const MarkInvoiceAsSentAPI =
  (id: string, onSuccess?: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "markInvoiceAsSent", true);

    axiosInstance
      .put(`/invoices/${id}/send`)
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "UPDATE_INVOICE_SEND_STATUS",
            payload: { id },
          });
          if (onSuccess) onSuccess(result?.data);
        } else {
          elseHandler(dispatch, "markInvoiceAsSent", result);
        }
        dispatchLoading(dispatch, "markInvoiceAsSent", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "markInvoiceAsSent")(err);
      });
  };

export const DeleteInvoiceAPI =
  (id: string, onSuccess?: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "deleteInvoice", true);

    axiosInstance
      .delete(`/invoices/${id}`)
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "DELETE_INVOICE",
            payload: id,
          });
          if (onSuccess) onSuccess(result?.data);
        } else {
          elseHandler(dispatch, "deleteInvoice", result);
        }
        dispatchLoading(dispatch, "deleteInvoice", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "deleteInvoice")(err);
      });
  };

export const stripPaymentIntentAPI =
  (data: any, onSuccess: any) => (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "stripPaymentIntent", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .post(`/invoices/${data?.invoice_id}/payment-intent`, formatedData, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          console.log("resultresultresultresult", result);
          if (result?.data?.url) {
            window.location.href = result.data.url;
          }
          if (onSuccess) {
            onSuccess(result?.data);
          }
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "stripPaymentIntent", undefined);
        } else elseHandler(dispatch, "stripPaymentIntent", result);
        dispatchLoading(dispatch, "stripPaymentIntent", false);
      })
      .catch((e) => {
        catchHandler(dispatch, "stripPaymentIntent")(e);
      });
  };

export const GetInvoiceUniqueCustomersAPI =
  () => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getInvoiceCustomers", true);

    axiosInstance
      .get(`/invoices/get-unique-customers`)
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "GET_INVOICE_UNIQUE_CUSTOMERS",
            payload: result?.data,
          });
        } else {
          elseHandler(dispatch, "getInvoiceCustomers", result);
        }
        dispatchLoading(dispatch, "getInvoiceCustomers", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getInvoiceCustomers")(err);
      });
  };

export const MarkInvoiceAsPaidManuallyAPI =
  (id: string, data: any, onSuccess?: any, onError?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "markInvoiceAsPaid", true);
    const formatedData = requestPayloadBodyFormate(data);

    axiosInstance
      .put(`/invoices/${id}/mark-as-paid-manual`, formatedData)
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          console.log(result, "invoiceinvoiceinvoice");
          dispatch({
            type: "UPDATE_INVOICE_PAID_STATUS",
            payload: result?.data,
          });
          dispatchToast(dispatch, "success", result?.message);
          if (onSuccess) onSuccess(result?.data);
        } else {
          elseHandler(dispatch, "markInvoiceAsPaid", result);
          if (onError) onError(result);
        }
        dispatchLoading(dispatch, "markInvoiceAsPaid", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "markInvoiceAsPaid")(err);
        if (onError) onError(err);
      });
  };

export const MarkFinalInvoiceAsPaidManuallyAPI =
  (id: string, onSuccess?: any, onError?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "markFinalInvoiceAsPaid", true);

    axiosInstance
      .put(`/invoices/${id}/final-invoice-paid`)
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "UPDATE_INVOICE_PAID_STATUS",
            payload: result?.data,
          });
          dispatchToast(dispatch, "success", result?.message);
          if (onSuccess) onSuccess(result?.data);
        } else {
          elseHandler(dispatch, "markFinalInvoiceAsPaid", result);
          if (onError) onError(result);
        }
        dispatchLoading(dispatch, "markFinalInvoiceAsPaid", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "markFinalInvoiceAsPaid")(err);
        if (onError) onError(err);
      });
  };
export const DownloadInvoicePdfAPI =
  (id: string, company_name: any, invoiceNo: string, messageApi: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "downloadInvoice", true);

    axiosInstance
      .get(`/invoices/download/${id}`, {
        responseType: "blob",
        headers: {
          Accept: "application/pdf",
        },
      })
      .then(async (response) => {
        if (Capacitor.isNativePlatform()) {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const reader = new FileReader();
          const blobToBase64 = (fileBlob: Blob): Promise<string> =>
            new Promise((resolve, reject) => {
              reader.onloadend = () => resolve(reader.result as string);
              reader.onerror = reject;
              reader.readAsDataURL(fileBlob);
            });

          try {
            const fileName = `SperrinMetal-Invoice_${invoiceNo}.pdf`;
            const result = await blobToBase64(blob);
            const base64Data = result.split(",")[1];
            const uniqueFileName = `${Date.now()}_${fileName}`;

            const savedFile = await Filesystem.writeFile({
              path: uniqueFileName,
              data: base64Data,
              directory: Directory.Cache,
            });

            await Share.share({
              title: `Invoice ${invoiceNo}`,
              url: savedFile.uri,
            });
          } catch (nativeErr) {
            console.error("[Capacitor Native Share Error]:", nativeErr);
          }
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `SperrinMetal-Invoice_${invoiceNo}.pdf`,
          );
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
        dispatchLoading(dispatch, "downloadInvoice", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "downloadInvoice")(err);
      })
      .finally(() => {
        messageApi.destroy();
      });
  };
